import { defineStore } from 'pinia';
import {
  EntitiesState,
  getInitialEntityState,
} from '@/store/common/entities-state';
import { Timetable } from '@/model/timetable';
import { createEntityGetters } from '@/store/common/entities-getters';
import { createEntityActions } from '@/store/common/entities-actions';
import { Collection } from '@/store/common/collections';
import moment from 'moment';
import { reactive } from 'vue';

const storeId = 'timetables';

export enum TimetableViewType {
  TIMETABLE = 'TIMETABLE',
  TIMETABLE_EXCEPTIONS = 'TIMETABLE_EXCEPTIONS',
}

export enum TimetableViewDate {
  PAST = 'PAST',
  FUTURE = 'FUTURE',
}

function sortByValidFrom(a: Timetable, b: Timetable): number {
  return moment(a.valid_from).isAfter(moment(b.valid_from)) ? -1 : 1;
}
const initialEntityState = reactive({
  ...getInitialEntityState<Timetable>(sortByValidFrom),
});
const state: EntitiesState<Timetable> & {
  viewType?: TimetableViewType;
  viewDate?: TimetableViewDate;
  lastDeletedEntityId?: number;
} = initialEntityState;
state.viewType = TimetableViewType.TIMETABLE;
state.viewDate = TimetableViewDate.FUTURE;
state.lastDeletedEntityId = null;

/**
 * Contient les timetables de l'employé sélectionné (défini dans employeesStore.currentEntity.id)
 */
export const useTimetablesStore = defineStore(storeId, {
  state: () => state,
  getters: {
    ...createEntityGetters<Timetable>(),
  },
  actions: {
    ...createEntityActions<Timetable>(
      Collection.TIMETABLES,
      initialEntityState,
    ),
    setViewType(viewType: TimetableViewType) {
      this.viewType = viewType;
    },
    setViewDate(viewDate: TimetableViewDate) {
      this.viewDate = viewDate;
    },
  },
});
